import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { RouterLink } from '@angular/router';
import { PDSService } from '../../../services/pds.service';

@Component({
  selector: 'app-travel-alerts',
  standalone: true,
  imports: [
    FooterComponent,
    StaticSearchComponent,
    CommonHeaderComponent,
    RouterLink,
  ],
  templateUrl: './travel-alerts.component.html',
  styleUrl: './travel-alerts.component.scss',
})
export class TravelAlertsComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle(
      'Travel Alerts | World2Cover Travel Insurance Australia',
    );
    this.metaService.updateTag({
      name: 'description',
      content: `Stay up to date with World2Cover travel alerts. Learn how global events like the Middle East conflict, COVID-19, and natural disasters may affect your travel insurance coverage.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Travel Alerts | World2Cover Travel Insurance Australia',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content: `Stay up to date with World2Cover travel alerts. Learn how global events like the Middle East conflict, COVID-19, and natural disasters may affect your travel insurance coverage.`,
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
